module.exports = __webpack_public_path__ + "static/img/移动端展示.aa2bc8b5.png";